// Midpoint quadratic curves round sample joins without overshooting the control
// polygon. Endpoints and stored time/price anchors are never changed.
export function traceSmoothStroke(path, points) {
  if (!points.length) return
  path.moveTo(points[0].x, points[0].y)
  let start = 0
  for (let end = 1; end < points.length; end++) {
    if (!points[end].corner && end !== points.length - 1) continue
    if (end === start + 1) path.lineTo(points[end].x, points[end].y)
    for (let i = start + 1; i < end; i++) {
      const control = points[i], next = points[i + 1]
      const target = i === end - 1 ? next : midpoint(control, next)
      path.quadraticCurveTo(control.x, control.y, target.x, target.y)
    }
    start = end
  }
}
const midpoint = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 })

// Erasing and box selection follow the rendered curve, not its control polygon.
// Adaptive subdivision bounds screen-space error while retaining a hard depth cap.
export function smoothStrokeHitPoints(points) {
  const result = []
  const flatten = (a, c, b, depth = 0) => {
    const error = Math.hypot(c.x - (a.x + b.x) / 2, c.y - (a.y + b.y) / 2) / 2
    if (error <= 0.35 || depth >= 10) { result.push(b); return }
    const ac = midpoint(a, c), cb = midpoint(c, b), middle = midpoint(ac, cb)
    flatten(a, ac, middle, depth + 1); flatten(middle, cb, b, depth + 1)
  }
  traceSmoothStroke({
    moveTo: (x, y) => result.push({ x, y }),
    lineTo: (x, y) => result.push({ x, y }),
    quadraticCurveTo: (cx, cy, x, y) => flatten(result.at(-1), { x: cx, y: cy }, { x, y }),
  }, points)
  return result
}
